import { HEIGHT_AVAILABLE_CSS_VAR } from '@/defs/observer'

import { getHeightAvailableConfig } from './getHeightAvailableConfig'

export const unobserveHeightAvailable = (el: HTMLElement) => {
  const config = getHeightAvailableConfig()
  if (!config) return
  config.elements.delete(el)
  config.observer.unobserve(el)
  el.style.removeProperty(HEIGHT_AVAILABLE_CSS_VAR)
  if (!config.elements.size) config.stop()
}
